import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CallWaiterService } from '@core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-call-waiter-indicator',
  templateUrl: './call-waiter-indicator.component.html',
  styleUrl: './call-waiter-indicator.component.scss',
  host: {
    '[class.active]': 'active()',
    '[class.main]': 'callWaiterMain()',
    '[class.another-round]': 'callWaiterAnotherRound()',
    '[class.request-bill]': 'callWaiterRequestBill()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallWaiterIndicatorComponent {

  private readonly callWaiterService = inject(CallWaiterService);

  public readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  public readonly callWaiterAnotherRound = toSignal(this.callWaiterService.tertiaryStatus$, {
    initialValue: true,
  });

  public readonly callWaiterRequestBill = toSignal(this.callWaiterService.secondaryStatus$, {
    initialValue: true,
  });

  public readonly active = computed(() => {
    return this.callWaiterMain() || this.callWaiterAnotherRound() || this.callWaiterRequestBill();
  });

}
